
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import React from "react";

const renderOptions = (options) => {
  return options.map((option) => (
    <FormControlLabel
      key={option.value}
      value={option.value}
      control={<Radio />}
      label={option.label}
    />
  ));
};

const FormikInputTest = ({
  field,
  form: { touched, errors },
  name,
  options,
  children,
  row,
  disabled,
  ...props
}) => {
  const fieldName = name || field.name;
  return (
    <React.Fragment>
    <TextField
        name={fieldName}
        disabled={disabled}
        {...field}  {...props}
        // fullwidth
    />
    </React.Fragment>
  );
};

export default FormikInputTest;
